import { RouteRecordRaw } from 'vue-router'
import CFSRetirementCalculator from '@/views/Clients/CFS/CFSRetirementCalculator.vue'
import CFSFAQs from '@/views/Clients/CFS/CFSFAQs.vue'
import { clientAuthGuard } from '@/router/clients/cfs/cfsRouteGuards.ts'
import ClientConfirmationDetails from '@/components/CFS/CFSClientConfirmationSteps/ClientConfirmationDetails.vue'
import ClientConfirmationSMS from '@/components/CFS/CFSClientConfirmationSteps/ClientConfirmationSMS.vue'
import ClientConfirmationChangeSuper from '@/components/CFS/CFSClientConfirmationSteps/ClientConfirmationChangeSuper.vue'
import ClientConfirmationSOADisplay from '@/components/CFS/CFSClientConfirmationSteps/ClientConfirmationSOADisplay.vue'
import { isAuthenticated, userRole } from '@/lib/AuthenticatorPlugin.ts'
import { getRootUrl } from '@/composables/getRootUrl.ts'
import ClientSetPassword from '@/components/CFS/CFSClientConfirmationSteps/ClientSetPassword.vue'
import ClientFeeConsentConfirmation from '@/components/CFS/CFSClientConfirmationSteps/ClientFeeConsentConfirmation.vue'
import ClientFeeConsentExpired from '@/components/CFS/CFSClientConfirmationSteps/ClientFeeConsentExpired.vue'
import PublicFooterNav from '@/app/components/public/PublicFooterNav.vue'
import PublicLayout from '@/app/layouts/PublicLayout.vue'
import NotFound from '@/app/views/NotFound.vue'
import CFSPublicHeaderNav from '@/app/components/public/clients/cfs/CFSPublicHeaderNav.vue'
import CFSHeaderActions from '@/app/components/public/clients/cfs/CFSHeaderActions.vue'
import { FeatureList, useLDFlag } from '@/lib/ldClient.ts'

const defaultSlots = {
  headerNav: CFSPublicHeaderNav,
  actions: CFSHeaderActions,
  footerNav: PublicFooterNav,
}

export default [
  {
    path: '/',
    name: 'home',
    component: PublicLayout,
    beforeEnter: () => {
      if (isAuthenticated.value) {
        return getRootUrl(userRole.value)
      }
    },
    children: [
      {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        components: {
          ...defaultSlots,
          default: NotFound,
        },
      },
      {
        path: '',
        name: 'homepage',
        components: {
          ...defaultSlots,
          default: () => import('@/views/Clients/CFS/CFSHome.vue'),
        },
      },
    ]
  },
  {
    path: '/cfsadmin',
    redirect: '/admin',
  },
  {
    path: '/cfs/faq',
    name: 'cfsFAQ',
    component: CFSFAQs,
  },
  {
    path: '/client/signIn',
    name: 'clientSignIn',
    component: ClientConfirmationDetails,
    beforeEnter: (to, from, next) => {
      const dtdEnabled = useLDFlag(FeatureList.ENABLE_DTD, false)
      if (dtdEnabled.value) next('/login')
      else next()
    }
  },
  {
    path: '/client/sms',
    name: 'clientSMS',
    component: ClientConfirmationSMS,
  },
  {
    path: '/client/set-password',
    name: 'clientSetPassword',
    component: ClientSetPassword,
  },
  {
    path: '/client/disclaimer/:adviceTargetName?',
    name: 'clientDisclaimer',
    component: ClientFeeConsentConfirmation,
    beforeEnter: clientAuthGuard,
  },
  {
    path: '/client/renew',
    name: 'clientRenewDisclaimer',
    component: ClientFeeConsentConfirmation,
    beforeEnter: clientAuthGuard,
  },
  {
    path: '/client/expired',
    name: 'clientConsentExpired',
    component: ClientFeeConsentExpired,
    beforeEnter: clientAuthGuard,
  },
  {
    path: '/client/confirm',
    name: 'clientConfirm',
    component: ClientConfirmationChangeSuper,
    beforeEnter: clientAuthGuard,
  },
  {
    path: '/client/soa',
    name: 'clientSoa',
    component: ClientConfirmationSOADisplay,
    beforeEnter: clientAuthGuard,
  },
  {
    path: '/cfs/retirementCalculator',
    name: 'cfsRetirementCalculator',
    component: CFSRetirementCalculator,
    beforeEnter: () => {
      const trackingScript = document.createElement('script')
      trackingScript.src = import.meta.env.VITE_CFS_TRACKING_URL
      trackingScript.type = 'text/javascript'
      trackingScript.async = true
      document.getElementsByTagName('head')[0].appendChild(trackingScript)
    },
  },
] as Array<RouteRecordRaw>
